<template>
  <div id="profile-info">
    <b-row>
      <b-col lg="9" cols="12" order="1" order-lg="1">
        <router-view />
      </b-col>

      <b-col lg="3" cols="12" order="2">
        <instructions-card />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InstructionsCard from "@/components/InstructionsCard.vue";

import {
  BRow,
  BCol,
  BContainer,
  BCardHeader,
  BCard,
  BCardText,
} from "bootstrap-vue";
export default {
  components: {
    BRow,
    BCol,
    BContainer,
    BCardHeader,
    BCard,
    BCardText,
    InstructionsCard,
  },
  beforeDestroy() {
    if (this.$store.hasModule("tecSupport"))
      this.$store.unregisterModule("tecSupport");
  },
};
</script>
